import React from "react";
import { useState } from "react";
import { FaMinus, FaPlus } from "react-icons/fa";
import Navbar from "../resuables/navbar";
import Footer from "../resuables/footer";
import QuickContact from "../resuables/quick-contact";
import { useEffect } from "react";
import AdmissionPic from "../resources/images/WhatsApp Image 2025-05-30 at 17.21.24_02b87b59.jpg";
function Admissions() {
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const faqsData = [
   
    {
      question: "How can I apply for admission?",
      answer:
        "You can either visit the school to collect and submit the admission form in person, or download it online, fill it out, and bring it to the school for submission.",
    },
    {
      question: "Is there an admission form available online?",
      answer:
        "Yes. You can download the admission form online, print it, and fill it out with all required details before submission.",
    },
    {
      question: "What documents are required during admission?",
      answer:
        "Parents should present a valid National ID. Wards must provide either a National ID or a National Health Insurance Scheme (NHIS) card. Academic records and birth certificates may also be required.",
    },
    {
      question: "How much is the application fee?",
      answer:
        "The application fee is 250 Ghana Cedis. Please note that this fee is non-refundable and must be paid in person during form submission.",
    },
    {
      question: "Where do I pay the application fee?",
      answer:
        "The fee must be paid in person at the school's Administration or Accounts Office during the form submission.",
    },
    {
      question: "Will I get confirmation after submitting the form?",
      answer:
        "Yes. Once your form and payment are received, you will be issued a confirmation slip as proof of submission.",
    },
    {
      question: "What happens after I submit the application?",
      answer:
        "The Admissions Office will review your application. If applicable, you will be contacted with interview dates and the next steps in the admissions process.",
    },
  ];

  const FAQItem = ({ faq, isOpen, onToggle }) => (
    <div className="faq-container">
      <button className="faq-item" onClick={onToggle}>
        <span className="faq-question">{faq.question}</span>
        <span>{isOpen ? <FaMinus size={20} /> : <FaPlus size={20} />}</span>
      </button>

      <p className={isOpen ? "faq-answer-open" : "faq-answer-close"}>
        {faq.answer}
      </p>
    </div>
  );

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="main">
      {/* <QuickContact /> */}
      <Navbar />
      <div className="content">
        <div className="content-header-container">
          <div className="bg-pattern"></div>

          <h2 className="content-name">Admissions</h2>
        </div>
        <br />
        <div className="content-page-img">
          <img src={AdmissionPic} alt="" />
        </div>
        <div className="content-body admission-process">
          <p>
            Welcome to the Admissions Page of Star of the East School Complex!
            At Star of the East School Complex, we are committed to providing a
            nurturing and academically stimulating environment where students
            can thrive. Our admissions process is designed to identify young
            learners who are eager to explore their full potential and
            contribute to a community of excellence. We warmly invite parents
            and guardians to enroll their children in our Junior High School,
            where character development, academic achievement, and personal
            growth are our top priorities. With a dedicated team of educators
            and state-of-the-art facilities, we are confident that your child’s
            educational journey will be both rewarding and enriching. Begin your
            child's future with us today!
          </p>

          <br />
          <br />
          <h2>Application Process</h2>
          <br />
          <ol>
            <li>
              <strong>Visit the School Premises: </strong>
              Prospective applicants and guardians can visit the Star of the
              East School Complex to collect and submit the admission form in
              person. Our staff will be available to assist with any inquiries
              or concerns during your visit.
            </li>
            <br />
            <li>
              <strong>Download the Admission Form: </strong>
              For convenience, you can download the admissions from{" "}
              <b>
                <a href="#">Here</a>
              </b>
              . After downloading, print the form and fill in all required
              information accurately.
            </li>
            <br />
            <li>
              <strong>Complete the Application Form: </strong>
              Whether you collect the form in person or download it , ensure
              that all sections of the form are filled in correctly and legibly.
              Attach any required supporting documents (such as copies of birth
              certificates and academic records).
            </li>
            <br />
            <li>
              <strong>Submit the Completed Form: </strong>
              You can submit the completed form in person at the school
              premises. Come along with the following items.
              <br />
              <span>Parent: Valid National Id</span> <br />
              <span>
                Your Ward : Valid National Id / National Health Insurance Scheme
                (NHIS) card.
              </span>
            </li>
            <br />
            <li>
              <strong>Pay the Application Fee: </strong>A NONREFUNDABLE FEE of{" "}
              <strong>250 cedis</strong> must be paid at the time of form
              submission in person at the school's Administration or Accounts
              Office. .
            </li>
            <br />
            <li>
              <strong>Confirmation of Submission: </strong>
              Once your form and payment are received, you will be provided with
              a confirmation slip. The admissions office will review your
              application, and you will be notified of the next steps, including
              interview dates if applicable.
            </li>
          </ol>

          <br />
          <br />
          <br />

          <h2>FAQs</h2>
          <br />
          <div className="faqs">
            {/* <h2 className="faqs-header">Frequently Asked Questions</h2> */}
            {faqsData.map((faq, index) => (
              <FAQItem
                key={index}
                faq={faq}
                isOpen={openIndex === index}
                onToggle={() => handleToggle(index)}
              />
            ))}
          </div>
        </div>
        {/* <p className="construction-note">Still Under Construction</p> */}
      </div>
      <Footer />
    </div>
  );
}

export default Admissions;
